import { HistoricoFiltro } from "app/api/classes/ProdutoApi";
import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useAppSelector } from "app/redux/hooks";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { PaginaPesquisaProdutoContainer } from "../PaginaPesquisaProdutoContainer";
import {
  FiltroPesquisaAnteriores,
  PesquisasAnteriores
} from "./PesquisasAnteriores";


export type PesquisasAnterioresContainerProps = {
  onVoltar: () => void,
  passos: Dict<string, () => void>
  regiaoRenderizada: string
  orcamentoForaModuloVendas: boolean
}

export const PesquisasAnterioresContainer = (props: PesquisasAnterioresContainerProps) => {
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const [pesquisasAnteriores, setPesquisasAnteriores] = useState<HistoricoFiltro[]>([]);
  const [mostrarCampoFiltrarCliente, setMostrarCampoFiltrarCliente] = useState<boolean>(false);
  const filtroInicialPesquisasAnteriores: FiltroPesquisaAnteriores = {
    idFiltro: 0,
    vendedorId: orcamento.Vendedor?.Codigo ?? null,
    codigoCliente: orcamento.CodigoCliente ?? null,
    checkFiltrarCliente: false,
  }


  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

  const onPesquisasAnteriores = async (filtrarCliente?: boolean) => {
    globalMU.blockUI();
    try {
      const resposta = await microuniversoApi.Produto.historicoFiltro(
        filtroInicialPesquisasAnteriores.idFiltro,
        filtroInicialPesquisasAnteriores.vendedorId,
        filtroInicialPesquisasAnteriores.codigoCliente,
        filtrarCliente!
          ? filtrarCliente
          : filtroInicialPesquisasAnteriores.checkFiltrarCliente
      );
      setPesquisasAnteriores(resposta);
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onPesquisaIndexada = async (idFiltro?: number) => {
    globalMU.blockUI();
    try {
      const resposta = await microuniversoApi.Produto.historicoFiltro(
        idFiltro! ? idFiltro : filtroInicialPesquisasAnteriores.idFiltro,
        filtroInicialPesquisasAnteriores.vendedorId,
        filtroInicialPesquisasAnteriores.codigoCliente,
        filtroInicialPesquisasAnteriores.checkFiltrarCliente
      );
      setPesquisasAnteriores(resposta);
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const atualizarExibicaoCampoFiltrarCliente = async () => {
    setMostrarCampoFiltrarCliente(
      await permitidoAcaoFuncionalidade(
        "PESQUISAS_ANTERIORES",
        "FILTRAR_CLIENTE"
      )
    );
  };

  const permitidoAcaoFuncionalidade = async (
    siglaFuncionalidade: string,
    acao: string
  ) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });


  const onPassoSelecionado = (passo: string) => {
    passosInterno.current.get(passo)()
  }

  const onVoltar = () => {
    props.onVoltar()
  }

  useEffect(() => {
    passosInterno.current.set("Pesquisas anteriores", () => { })
    onPesquisasAnteriores();
    atualizarExibicaoCampoFiltrarCliente();
  }, []);

  return (
    <>
      <Breadcrumb2Container
        passos={passosInterno.current.keysToList()}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        id="PesquisasAnterioresContainer"
        onPassoSelecionado={onPassoSelecionado}
        onBotaoVoltarClicado={onVoltar}
      />

      <PesquisasAnteriores
        mostrarCampoFiltrarCliente={
          mostrarCampoFiltrarCliente &&
          filtroInicialPesquisasAnteriores.codigoCliente != null
        }
        pesquisasAnteriores={pesquisasAnteriores}
        onCheckPesquisar={(filtrarCliente) =>
          onPesquisasAnteriores(filtrarCliente)
        }
        onSelecionar={(idFiltro) => onPesquisaIndexada(idFiltro)}
        onPesquisar={(filtro) => {
          renderizarComponentReact(
            <PaginaPesquisaProdutoContainer
              chamadoParaInserirProdutoNoOrcamento={false}
              chamadoPeloTrocarProduto={false}
              filtroPesquisaAnterior={filtro}
              passos={props.passos.remove("Pesquisar Produtos")}
              onVoltar={() => onPassoSelecionado("Itens")}
              foraOrcamento={props.orcamentoForaModuloVendas}
              regiaoRenderizada={props.regiaoRenderizada} />,
            props.regiaoRenderizada,
            true
          );
        }}
      />
    </>
  );
};
